
<template>
            <div class="flex_spicy" v-if="spicy.id>0">
              <!-- {{spicy}} -->
              <span class="flex_icon_sp">
                    <span class="fill_sp" v-for="sp in spicy.id" :key="sp.id">
                       <img src="~@/assets/sp_fill.svg" alt="Hot">
                    </span>
                     <span class="empty_sp" v-for=" i in (3 - spicy.id)" :key="i">
                        <img src="~@/assets/sp_empty.svg" alt="empty">
                </span>
              </span>
          </div>
</template>

<script>
export default {
   name:'block_spicy',
   props:['spicy']
}
</script>

<style lang="scss" scoped>
  .flex_icon_sp{
       display: flex;
    align-items: center;
    position: absolute;
    top: 48px;
    right: 2%;
    width: auto;
    text-align: center;
    justify-content: center;
  img{
   display: block;
    width: 20px;
    height: 28px;
    object-fit: contain;
    filter: drop-shadow(0px 4px 6px black);
  }
  }
@media (max-width: 787px) {
  .flex_allergi , .flex_icon_sp{
  img{
       display: block;
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
}
}
</style>